import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ParametroCupomService = 
{
    deletarExcelParametroCupom(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'cupom/excel/deletar', 'excelParametroCupomDeletar');
    },
    salvarExcelParametroCupom(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'cupom/excel', 'excelCupom');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('cupom/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('cupom/eventGrid', {});
    }
}

export default ParametroCupomService;